export const teacherLists = [
    {
      key: "1",
      img: "assets/img/teachers/teacher-01.jpg",
      id: "TCH0001",
      name: "Teresa",
      class: "Year 3, Jupiter",
      subject: "Physics",
      email: "teresa@example.com",
      phone: "+601 82392 37359",
      dateofJoin: "25 Mar 2025",
      status: "Active",
      statusclass: "badge badge-soft-success",
    },
    {
      key: "2",
      img: "assets/img/teachers/teacher-02.jpg",
      id: "TCH0002",
      name: "Daniel",
      class: "Year 2, Mars",
      subject: "Computer",
      email: "daniel@example.com",
      phone: "+601 56752 86742",
      dateofJoin: "28 Mar 2025",
      status: "Active",
      statusclass: "badge badge-soft-success",
    },
    {
      key: "3",
      img: "assets/img/teachers/teacher-05.jpg",
      id: "TCH0003",
      name: "Hellana",
      class: "Year 6, Jupiter",
      subject: "English",
      email: "hellana@example.com",
      phone: "+601 23566 52683",
      dateofJoin: "03 Apr 2025",
      status: "Inactive",
      statusclass: "badge badge-soft-danger",
    },
    {
      key: "4",
      img: "assets/img/teachers/teacher-06.jpg",
      id: "TCH0004",
      name: "Erickson",
      class: "Year 6, Mars & Year 7, Jupiter",
      subject: "Bahasa Melayu",
      email: "erickson@example.com",
      phone: "+601 14259 85573",
      dateofJoin: "05 Apr 2025",
      status: "Inactive",
      statusclass: "badge badge-soft-danger",
    },
    {
      key: "5",
      img: "assets/img/teachers/teacher-07.jpg",
      id: "TCH0005",
      name: "Morgan",
      class: "Year 8, Saturn",
      subject: "Env Science",
      email: "morgan@example.com",
      phone: "+601 63204 35730",
      dateofJoin: "20 Mar 2025",
      status: "Active",
      statusclass: "badge badge-soft-success",
    },
    {
      key: "6",
      img: "assets/img/teachers/teacher-06.jpg",
      id: "T849122",
      name: "Aaron",
      class: "Year 1, Jupiter",
      subject: "Chemistry",
      email: "aaron@example.com",
      phone: "+601 26267 80542",
      dateofJoin: "12 Mar 2025",
      status: "Active",
      statusclass: "badge badge-soft-success",
    },
    {
      key: "7",
      img: "assets/img/teachers/teacher-09.jpg",
      id: "TCH0007",
      name: "Jacquelin",
      class: "Year 4, Jupiter",
      subject: "Maths",
      email: "jacquelin@example.com",
      phone: "+601 77502 54845",
      dateofJoin: "20 Mar 2025",
      status: "Active",
      statusclass: "badge badge-soft-success",
    },
    {
      key: "8",
      img: "assets/img/students/student-10.jpg",
      id: "TCH0008",
      name: "Raul",
      class: "Year 9, Saturn",
      subject: "Biology",
      email: "raul@example.com",
      phone: "+601 67845 78784",
      dateofJoin: "27 Mar 2025",
      status: "Inactive",
      statusclass: "badge badge-soft-danger",
    },
    {
      key: "9",
      img: "assets/img/students/student-11.jpg",
      id: "TCH0009",
      name: "Elizabeth",
      class: "Year 8, Mars",
      subject: "Economics",
      email: "elizabeth@example.com",
      phone: "+601 97846 84518",
      dateofJoin: "10 Jan 2025",
      status: "Active",
      statusclass: "badge badge-soft-success",
    },
    {
      key: "10",
      img: "assets/img/teachers/teacher-03.jpg",
      id: "TCH0010",
      name: "Edward",
      class: "Year 9, Saturn & Year 10, Saturn",
      subject: "Finance",
      email: "edward@example.com",
      phone: "+601 56187 87489",
      dateofJoin: "18 Jun 2025",
      status: "Active",
      statusclass: "badge badge-soft-success",
    },
    {
      key: "11",
      img: "assets/img/teachers/teacher-04.jpg",
      id: "TCH0011",
      name: "Maria",
      class: "Year 1, Jupiter",
      subject: "English",
      email: "maria@example.com",
      phone: "+601 97846 84518",
      dateofJoin: "22 Mar 2018",
      status: "Active",
      statusclass: "badge badge-soft-success",
    },
  ];